'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$GetAvailableCredentials(url, via) {
  this.YW = null;
  this.YX = null;
  this.YW = url;
  this.YX = via;
}
export { $c_Lpresto_types$proto$GetAvailableCredentials as $c_Lpresto_types$proto$GetAvailableCredentials };
$p = $c_Lpresto_types$proto$GetAvailableCredentials.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$GetAvailableCredentials;
/** @constructor */
function $h_Lpresto_types$proto$GetAvailableCredentials() {
}
export { $h_Lpresto_types$proto$GetAvailableCredentials as $h_Lpresto_types$proto$GetAvailableCredentials };
$h_Lpresto_types$proto$GetAvailableCredentials.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$proto$GetAvailableCredentials) && ((this.YW === x$0.YW) && (this.YX === x$0.YX))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "GetAvailableCredentials";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.YW;
  }
  if ((n === 1)) {
    return this.YX;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$GetAvailableCredentials(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.l9)));
}
export { $isArrayOf_Lpresto_types$proto$GetAvailableCredentials as $isArrayOf_Lpresto_types$proto$GetAvailableCredentials };
var $d_Lpresto_types$proto$GetAvailableCredentials = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$GetAvailableCredentials, "presto.types$proto$GetAvailableCredentials", ({
  l9: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$GetAvailableCredentials as $d_Lpresto_types$proto$GetAvailableCredentials };
//# sourceMappingURL=presto.types$proto$-Get-Available-Credentials.js.map
